import {
  CHANGE_PASSWORD_API,
  COUNTRIES_API,
  FETCH_EMPLOYMENT_DETAILS_API,
  FETCH_FINANCIAL_DETAILS_API,
  FETCH_PERSONAL_DETAILS_API,
  INDUSTRIES_API,
  LOGOUT_API,
  REFRESH_TOKEN_API,
  SIGN_IN_API,
  SIGNUP_API,
  SUBMIT_EMPLOYMENT_DETAILS_API,
  SUBMIT_FINANCIAL_DETAILS_API,
  SUBMIT_DOCUMENTS_API,
  UPDATE_EMPLOYMENT_DETAILS_API,
  UPDATE_FINANCIAL_DETAILS_API,
  UPDATE_PERSONAL_DETAILS_API,
  SUBMIT_PERSONAL_DETAILS_API,
  ONBOARDING_STATUS_API,
  ONBOARDING_VALIDATE_API,
  ONBOARDING_REGISTER_API,
  FETCH_TRADING_EXPERIENCE_API,
  SUBMIT_TRADING_EXPERIENCE_API,
  UPDATE_TRADING_EXPERIENCE_API,
  SUBMIT_TRADING_ACCOUNTS_API,
  FETCH_TRADING_ACCOUNTS_API,
  SEND_OTP_API,
  VERIFY_OTP_API,
  FETCH_USER_API,
  SOCIAL_SIGN_IN_API,
  SOCIAL_SIGNUP_API,
  EMAIL_VERIFICATION_API,
  PHONE_VERIFICATION_API,
  FETCH_ACCOUNT_TYPES_API,
  FETCH_PLATFORM_SERVERS_API,
  INITIATE_FORGOT_PASSWORD_API,
  FORGOT_PASSWORD_RESET_API,
  UPDATE_LEVERAGE_API,
  AccountIdParamValue,
  INITIATE_RESET_PASSWORD_API,
  RESET_PASSWORD_API,
  FETCH_INTRODUCING_BROKER_APPLICATION_API,
  SUBMIT_INTRODUCING_BROKER_APPLICATION_API,
  FETCH_REFERRAL_LINKS_API,
  SUBMIT_REFERRAL_LINK_API,
  FETCH_NEWS_API,
  FETCH_CLIENT_CABINET_CLIENT_COMMISSION_API,
  FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION_API,
  FETCH_CLIENT_CABINET_COMMISSION_SETTINGS_API,
  FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD_API,
  FETCH_CLIENT_CABINET_IB_REFERRALS_API,
  FETCH_CLIENT_CABINET_IB_TRANSACTIONS_API,
  FETCH_CLIENT_CABINET_IB_COMMISSIONS_API,
  MONITORING_CLIENTS_API,
  MONITORING_META_CLIENTS_API,
  TRANSFERS_API,
  FETCH_CONTACTS_API,
  SUBMIT_CONTACT_API,
  FETCH_SWAP_FREE_DETAILS_API,
  LoginSidParamValue,
} from "_constants";
import { customerManagementRequest } from "_helpers";
import axios from "axios";

/**
@param {Object} user - user details
@param {String} user.email - email of the user
@param {String} user.passcode
@param {String} user.country
@param {String} user.firstName
@param {String} user.lastName
@param {String} user.phoneNumber

@returns {Promise}
*/

const signup = (user) => {
  return customerManagementRequest.post(SIGNUP_API, user);
};

/**
@param {Object} user - user details
@param {String} user.email - email of the user
@param {String} user.password - password of the user

@returns {Promise}
*/

const signIn = (user) => {
  return customerManagementRequest.post(SIGN_IN_API, user);
};

/**
@param {Object} changePasswordData
@param {String} changePasswordData.passcode - email of the user
@param {String} refreshTokenData.newPasscode - password of the user

@returns {Promise}
*/

const changePassword = (changePasswordData) => {
  return customerManagementRequest.post(
    CHANGE_PASSWORD_API,
    changePasswordData
  );
};

/**
@param {Object} refreshTokenData 
@param {String} refreshTokenData.email - email of the user
@param {String} refreshTokenData.refreshToken - password of the user

@returns {Promise}
*/

const refreshToken = (refreshTokenData) => {
  return customerManagementRequest.post(REFRESH_TOKEN_API, refreshTokenData);
};

const logout = () => {
  return customerManagementRequest.post(LOGOUT_API);
};

/**
@param {Object[]} poiDocs
@param {String} poiDocs[].docType
@param {String} poiDocs[].country
@param {String} poiDocs[].docFilePath
@param {String} poiDocs[].docType
@param {String} poiDocs[].documentId
@param {String} poiDocs[].idDocSubType
@param {String} poiDocs[].idDocType

@param {Object[]} poiDocs[].documentDetails
@param {String} poiDocs[].documentDetails[].docFilePath
@param {String} poiDocs[].documentDetails[].docSide


@returns {Promise}
*/

const submitDocuments = (poiDocs) => {
  return axios.all(
    poiDocs.map((document) =>
      customerManagementRequest.post(SUBMIT_DOCUMENTS_API, document)
    )
  );
};

/**
@param {Object} employmentDetails
@param {String} employmentDetails.employmentStatus
@param {String} employmentDetails.industry

@returns {Promise}
*/

const submitEmploymentDetails = (employmentDetails) => {
  return customerManagementRequest.post(
    SUBMIT_EMPLOYMENT_DETAILS_API,
    employmentDetails
  );
};

/**
@param {Object} employmentDetails
@param {String} employmentDetails.employmentStatus
@param {String} employmentDetails.industry

@returns {Promise}
*/

const updateEmploymentDetails = (employmentDetails) => {
  return customerManagementRequest.put(
    UPDATE_EMPLOYMENT_DETAILS_API,
    employmentDetails
  );
};

const fetchEmploymentDetails = () => {
  return customerManagementRequest.get(FETCH_EMPLOYMENT_DETAILS_API);
};

const fetchFinancialDetails = () => {
  return customerManagementRequest.get(FETCH_FINANCIAL_DETAILS_API);
};

/**
@param {Object} financialDetails
@param {String} financialDetails.annualIncome
@param {String} financialDetails.employmentStatus
@param {String} financialDetails.intendedDepositAmount
@param {String} financialDetails.preferredPlatform
@param {String} financialDetails.sourceOfIncome
@param {String} financialDetails.tradingExperience
@param {String} financialDetails.understandRisk

@returns {Promise}
*/

const submitFinancialDetails = (financialDetails) => {
  return customerManagementRequest.post(
    SUBMIT_FINANCIAL_DETAILS_API,
    financialDetails
  );
};

/**
@param {Object} financialDetails
@param {String} financialDetails.annualIncome
@param {String} financialDetails.employmentStatus
@param {String} financialDetails.intendedDepositAmount
@param {String} financialDetails.preferredPlatform
@param {String} financialDetails.sourceOfIncome
@param {String} financialDetails.tradingExperience
@param {String} financialDetails.understandRisk

@returns {Promise}
*/

const updateFinancialDetails = (financialDetails) => {
  return customerManagementRequest.put(
    UPDATE_FINANCIAL_DETAILS_API,
    financialDetails
  );
};

const fetchPersonalDetails = () => {
  return customerManagementRequest.get(FETCH_PERSONAL_DETAILS_API);
};

/**
@param {Object} personalDetails
@param {String} personalDetails.birthdate
@param {String} personalDetails.identificationNumber
@param {String} personalDetails.postalCode
@param {String} personalDetails.residenceStatus
@param {String} personalDetails.streetAddress
@param {String} personalDetails.taxIdentificationNumber

@returns {Promise}
*/

const submitPersonalDetails = (personalDetails) => {
  return customerManagementRequest.post(
    SUBMIT_PERSONAL_DETAILS_API,
    personalDetails
  );
};

/**
@param {Object} personalDetails
@param {String} personalDetails.birthdate
@param {String} personalDetails.identificationNumber
@param {String} personalDetails.postalCode
@param {String} personalDetails.residenceStatus
@param {String} personalDetails.streetAddress
@param {String} personalDetails.taxIdentificationNumber

@returns {Promise}
*/

const updatePersonalDetails = (personalDetails) => {
  return customerManagementRequest.put(
    UPDATE_PERSONAL_DETAILS_API,
    personalDetails
  );
};

const fetchCountries = () => {
  return customerManagementRequest.get(COUNTRIES_API);
};

const fetchIndustries = () => {
  return customerManagementRequest.get(INDUSTRIES_API);
};

const fetchOnboardingStatus = () => {
  return customerManagementRequest.get(ONBOARDING_STATUS_API);
};

/**
@param {Object} onboardingDetails
@param {String} onboardingDetails.country
@param {String} onboardingDetails.dateOfBirth
@param {String} onboardingDetails.email
@param {String} onboardingDetails.fullName
@param {String} onboardingDetails.idNumber
@param {String} onboardingDetails.phoneNumber

@returns {Promise}
*/

const onboardingValidate = (onboardingDetails) => {
  return customerManagementRequest.post(
    ONBOARDING_VALIDATE_API,
    onboardingDetails
  );
};

/**
@param {Object} registerDetails
@param {String} registerDetails.country
@param {String} registerDetails.dateOfBirth
@param {String} registerDetails.email
@param {String} registerDetails.firstName
@param {String} registerDetails.lastName
@param {String} registerDetails.iamId
@param {String} registerDetails.idNumber
@param {String} registerDetails.password
@param {String} registerDetails.phoneNumber
@param {Number} registerDetails.linkId
@param {Number} registerDetails.mLinkId
@param {Number} registerDetails.partnerId
@param {String} registerDetails.utmCampaign
@param {String} registerDetails.utmContent
@param {String} registerDetails.utmMedium
@param {String} registerDetails.utmSource
@param {String} registerDetails.utmTerm

@returns {Promise}
*/

const onboardingRegister = (registerDetails) => {
  return customerManagementRequest.post(
    ONBOARDING_REGISTER_API,
    registerDetails
  );
};

const fetchTradingExperience = () => {
  return customerManagementRequest.get(FETCH_TRADING_EXPERIENCE_API);
};

const submitTradingExperience = (tradingExperience) => {
  return customerManagementRequest.post(
    SUBMIT_TRADING_EXPERIENCE_API,
    tradingExperience
  );
};

const updateTradingExperience = (tradingExperience) => {
  return customerManagementRequest.put(
    UPDATE_TRADING_EXPERIENCE_API,
    tradingExperience
  );
};

/**
@param {Object} tradingAccounts
@param {Number} tradingAccounts.accountTypeId
@param {String} tradingAccounts.currency
@param {Number} tradingAccounts.leverage

@returns {Promise}
*/

const submitTradingAccounts = (tradingAccounts, scope) => {
  return customerManagementRequest.post(
    SUBMIT_TRADING_ACCOUNTS_API,
    tradingAccounts,
    { params: { scope } }
  );
};

const fetchTradingAccounts = () => {
  return customerManagementRequest.get(FETCH_TRADING_ACCOUNTS_API);
};

/**
@param {Object} sendOTPDetails
@param {String} sendOTPDetails.phoneNumber
@param {String} sendOTPDetails.platform
@param {String} sendOTPDetails.purpose

@returns {Promise}
*/

const sendOTP = (sendOTPDetails) => {
  return customerManagementRequest.post(SEND_OTP_API, sendOTPDetails);
};

/**
@param {Object} verifyOTPDetails
@param {String} verifyOTPDetails.phoneNumber
@param {String} verifyOTPDetails.platform
@param {String} verifyOTPDetails.purpose

@returns {Promise}
*/

const verifyOTP = (verifyOTPDetails) => {
  return customerManagementRequest.post(VERIFY_OTP_API, verifyOTPDetails);
};

const fetchUser = () => {
  return customerManagementRequest.get(FETCH_USER_API);
};

/**
@param {Object} socialSignInDetails
@param {String} socialSignInDetails.code
f
@returns {Promise}
*/

const socialSignIn = (socialSignInDetails) => {
  return customerManagementRequest.post(
    SOCIAL_SIGN_IN_API,
    socialSignInDetails
  );
};

/**
@param {Object} socialSignupDetails
@param {String} socialSignupDetails.country
@param {String} socialSignupDetails.phoneNumber
@param {String} socialSignupDetails.firstName
@param {String} socialSignupDetails.lastName


@returns {Promise}
*/

const socialSignup = (socialSignupDetails) => {
  return customerManagementRequest.post(SOCIAL_SIGNUP_API, socialSignupDetails);
};

/**
@param {Object} emailVerificationDetails
@param {String} emailVerificationDetails.email

@returns {Promise}
*/

const emailVerification = (emailVerificationDetails) => {
  return customerManagementRequest.post(
    EMAIL_VERIFICATION_API,
    emailVerificationDetails
  );
};

/**
@param {Object} phoneVerificationDetails
@param {String} phoneVerificationDetails.phoneNumber

@returns {Promise}
*/

const phoneVerification = (phoneVerificationDetails) => {
  return customerManagementRequest.post(
    PHONE_VERIFICATION_API,
    phoneVerificationDetails
  );
};

const fetchAccountTypes = (params) => {
  return customerManagementRequest.get(FETCH_ACCOUNT_TYPES_API, { params });
};

const fetchPlatformServers = () => {
  return customerManagementRequest.get(FETCH_PLATFORM_SERVERS_API);
};

/**
@param {Object} initiateForgotPasswordDetails
@param {String} initiateForgotPasswordDetails.email

@returns {Promise}
*/

const initiateForgotPassword = (initiateForgotPasswordDetails) => {
  return customerManagementRequest.post(
    INITIATE_FORGOT_PASSWORD_API,
    initiateForgotPasswordDetails
  );
};

/**
@param {Object} forgotPasswordResetDetails
@param {String} forgotPasswordResetDetails.email
@param {String} forgotPasswordResetDetails.newPassword

@returns {Promise}
*/

const forgotPasswordReset = (forgotPasswordResetDetails) => {
  return customerManagementRequest.post(
    FORGOT_PASSWORD_RESET_API,
    forgotPasswordResetDetails
  );
};

/**
@param {Object} updateLeverageDetails
@param {String} updateLeverageDetails.accountId
@param {String} updateLeverageDetails.leverage

@returns {Promise}
*/

const updateLeverage = (updateLeverageDetails) => {
  const url = UPDATE_LEVERAGE_API.replace(
    AccountIdParamValue,
    updateLeverageDetails.accountId
  );
  return customerManagementRequest.put(url, updateLeverageDetails);
};

/**
@param {Object} initiateResetPasswordDetails
@param {String} initiateResetPasswordDetails.accountId

@returns {Promise}
*/

const initiateResetPassword = (initiateResetPasswordDetails) => {
  const url = INITIATE_RESET_PASSWORD_API.replace(
    AccountIdParamValue,
    initiateResetPasswordDetails.accountId
  );
  return customerManagementRequest.get(url);
};

/**
@param {Object} resetPasswordDetails
@param {String} resetPasswordDetails.accountId
@param {String} resetPasswordDetails.newPassword


@returns {Promise}
*/

const resetPassword = (resetPasswordDetails) => {
  return customerManagementRequest.put(
    RESET_PASSWORD_API,
    resetPasswordDetails
  );
};

const fetchIntroducingBrokerApplication = () => {
  return customerManagementRequest.get(
    FETCH_INTRODUCING_BROKER_APPLICATION_API
  );
};

const submitIntroducingBrokerApplication = (
  introducingBrokerApplicationDetails
) => {
  return customerManagementRequest.post(
    SUBMIT_INTRODUCING_BROKER_APPLICATION_API,
    introducingBrokerApplicationDetails
  );
};

const fetchReferralLinks = () => {
  return customerManagementRequest.get(FETCH_REFERRAL_LINKS_API);
};

/**
@param {Object} referralLinkDetails
@param {String} referralLinkDetails.name

@returns {Promise}
*/

const submitReferralLink = (referralLinkDetails) => {
  return customerManagementRequest.post(
    SUBMIT_REFERRAL_LINK_API,
    referralLinkDetails
  );
};


/**
@param {Object} newsParams
@param {String} newsParams.from
@param {String} newsParams.to

@returns {Promise}
*/

const fetchNews = (newsParams) => {
  return customerManagementRequest.get(FETCH_NEWS_API, { params: newsParams });
};

/**
@param {Object} accountCommissionParams
@param {String} accountCommissionParams.currency
@param {String} accountCommissionParams.from
@param {String} accountCommissionParams.to


@returns {Promise}
*/

const fetchClientCabinetAccountCommission = (accountCommissionParams) => {
  return customerManagementRequest.post(
    FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION_API,
    accountCommissionParams
  );
};

/**
@param {Object} transfersDetails
@param {String} transfersDetails.fromAccountId
@param {String} transfersDetails.toAccountId
@param {String} transfersDetails.transferAmount

@returns {Promise}
*/

const transfers = (transfersDetails) => {
  return customerManagementRequest.post(TRANSFERS_API, transfersDetails);
};

/**
@param {Object} clientCommissionParams
@param {String} clientCommissionParams.currency
@param {String} clientCommissionParams.from
@param {String} clientCommissionParams.to


@returns {Promise}
*/

const fetchClientCabinetClientCommission = (clientCommissionParams) => {
  return customerManagementRequest.post(
    FETCH_CLIENT_CABINET_CLIENT_COMMISSION_API,
    clientCommissionParams
  );
};

const fetchClientCabinetCommissionSettings = () => {
  return customerManagementRequest.get(
    FETCH_CLIENT_CABINET_COMMISSION_SETTINGS_API
  );
};

const fetchClientCabinetIBCommissions = () => {
  return customerManagementRequest.get(FETCH_CLIENT_CABINET_IB_COMMISSIONS_API);
};

/**
@param {Object} ibPerformanceDashboardParams
@param {String} ibPerformanceDashboardParams.currency
@param {String} ibPerformanceDashboardParams.from
@param {String} ibPerformanceDashboardParams.to


@returns {Promise}
*/

const fetchClientCabinetIBPerformanceDashboard = (
  ibPerformanceDashboardParams
) => {
  return customerManagementRequest.get(
    FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD_API,
    { params: ibPerformanceDashboardParams }
  );
};

/**
@param {Object} ibReferralsParams
@param {String} ibReferralsParams.currency
@param {String} ibReferralsParams.from
@param {String} ibReferralsParams.to


@returns {Promise}
*/

const fetchClientCabinetIBReferrals = (ibReferralsParams) => {
  return customerManagementRequest.post(
    FETCH_CLIENT_CABINET_IB_REFERRALS_API,
    ibReferralsParams
  );
};

const fetchClientCabinetIBTransactions = () => {
  return customerManagementRequest.get(
    FETCH_CLIENT_CABINET_IB_TRANSACTIONS_API
  );
};

/**
@param {Object} monitorClientsParams
@param {String} monitorClientsParams.clientId
@param {String} monitorClientsParams.sessionId


@returns {Promise}
*/

const monitorClients = (monitorClientsParams) => {
  return customerManagementRequest.post(
    MONITORING_CLIENTS_API,
    monitorClientsParams
  );
};

/**
@param {Object} monitorMetaClientsParams
@param {String} monitorMetaClientsParams.browserPixel
@param {String} monitorMetaClientsParams.clickId


@returns {Promise}
*/

const monitorMetaClients = (monitorMetaClientsParams) => {
  return customerManagementRequest.post(
    MONITORING_META_CLIENTS_API,
    monitorMetaClientsParams
  );
};


/**
@param {Object} submitContactDetails
@param {String} submitContactDetails.contact
@param {Boolean} submitContactDetails.isPrimary
@param {String} submitContactDetails.otpCode
@param {String} submitContactDetails.type

@returns {Promise}
*/

const fetchContacts = () => {
  return customerManagementRequest.get(FETCH_CONTACTS_API);
};

const submitContact = (submitContactDetails) => {
  return customerManagementRequest.post(
    SUBMIT_CONTACT_API,
    submitContactDetails
  );
};

/**
@param {Object} swapFreeDetailsParams
@param {Integer} swapFreeDetailsParams.loginSid

@returns {Promise}
*/

const fetchSwapFreeDetails = (swapFreeDetailsParams) => {
  const url = FETCH_SWAP_FREE_DETAILS_API.replace(
    LoginSidParamValue,
    swapFreeDetailsParams.loginSid
  );
  return customerManagementRequest.get(url);
};

/**
@param {Object} swapFreeDetails
@param {Integer} swapFreeParams.loginSid
@param {Object} swapFreeParams.form

@returns {Promise}
*/

const submitSwapFree = (swapFreeDetails) => {
  const { loginSid, ...data } = swapFreeDetails || {};
  const url = FETCH_SWAP_FREE_DETAILS_API.replace(LoginSidParamValue, loginSid);
  return customerManagementRequest.post(url, data);
};

export const customerManagementService = {
  signIn,
  refreshToken,
  logout,
  submitDocuments,
  submitEmploymentDetails,
  updateEmploymentDetails,
  fetchEmploymentDetails,
  fetchFinancialDetails,
  submitFinancialDetails,
  updateFinancialDetails,
  signup,
  changePassword,
  fetchPersonalDetails,
  submitPersonalDetails,
  updatePersonalDetails,
  fetchCountries,
  fetchIndustries,
  fetchOnboardingStatus,
  fetchTradingAccounts,
  submitTradingAccounts,
  sendOTP,
  verifyOTP,
  fetchUser,
  socialSignIn,
  socialSignup,
  emailVerification,
  phoneVerification,
  fetchAccountTypes,
  fetchPlatformServers,
  initiateForgotPassword,
  forgotPasswordReset,
  updateLeverage,
  initiateResetPassword,
  resetPassword,
  fetchIntroducingBrokerApplication,
  submitIntroducingBrokerApplication,
  fetchReferralLinks,
  submitReferralLink,
  fetchNews,
  fetchClientCabinetAccountCommission,
  fetchClientCabinetClientCommission,
  fetchClientCabinetCommissionSettings,
  fetchClientCabinetIBCommissions,
  fetchClientCabinetIBPerformanceDashboard,
  fetchClientCabinetIBReferrals,
  fetchClientCabinetIBTransactions,
  monitorClients,
  monitorMetaClients,
  transfers,
  fetchContacts,
  submitContact,
  fetchSwapFreeDetails,
  submitSwapFree,
  onboardingValidate,
  onboardingRegister,
  fetchTradingExperience,
  submitTradingExperience,
  updateTradingExperience,
};
